import { SDK } from '@absmartly/javascript-sdk';
import { EventLogger } from '@absmartly/javascript-sdk/types/sdk';

type GetAbSmartlySDKProps = {
  eventLogger?: EventLogger;
};
export const getAbSmartlySDK = ({ eventLogger }: GetAbSmartlySDKProps) =>
  new SDK({
    endpoint:
      process.env.NEXT_PUBLIC_ABSMARTLY_URL ||
      'https://nerdwallet.absmartly.io/v1',
    apiKey: process.env.NEXT_PUBLIC_ABSMARTLY_SDK_KEY || '',
    environment: process.env.NEXT_PUBLIC_DEPLOYABLE_ENV || 'prod',
    application: 'cardfinder',
    eventLogger: eventLogger ? eventLogger : undefined,
  });
